import { usePermissions } from '@mint-lib/profile-helpers';

export const useIsReadOnlyUser = () => {
  const { permissions } = usePermissions();
  const isReadOnlyUser = permissions.dataManagementHubFeature === 'view';

  return isReadOnlyUser;
};
